import axios from 'axios'

export const state = {
  cities: null,
}

export const getters = {
  cities: (state) => state.cities,
  cityOptions: (state) =>
    state.cities &&
    state.cities.map(({ title }) => ({ id: title, label: title })),
}

export const mutations = {
  SET_CITIES(state, cities) {
    state.cities = cities
  },
}

export const actions = {
  fetchAllCities({ commit, state, rootState }) {
    return axios.get('/api/cities').then((response) => {
      const cities = response.data
      commit('SET_CITIES', cities)
      return cities
    })
  },
}
